<!--
* UIID: UI-DLB-MAP-130
* UI Name: Mapper Version History
* Modify Date: 2020/05/19
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    :options="options"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="popup-history"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>
        {{ $t('lbl.mapManager.mapperVersionHistory.header') }}
      </v-card-title>
      <!-- [E]  Popup title-->
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="analyzed-dialog matched-map-list-dialog">
      <!-- [S]  Popup top text-->
      <v-card-text class="ml-4 pa-0 popup-title">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <span class="title-file-name--text">{{ mapperName }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [S]  Popup top text-->

      <!-- [S]  Popup top buttons-->
      <v-card-text class="top-btn-display-m">
        <v-row class="ma-0 mb-2">
          <v-col cols="12" class="pa-0">
            <v-btn
              class="mr-4 btn btn-popup-search float-right"
              color="primary"
              tile
              dark
              @click="openCheckIn"
              v-if="this.options.item.action != 'mapbuilder' && !versionList.HIDE_CHECK_IN"
            >
              {{ $t('btn.mapManager.checkIn') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup top buttons-->

      <!-- [S]  Popup body-->
      <v-card-text class="content-version-section">
        <v-row class="content-covering-m pt-0 pb-0">
          <v-col cols="12" class="pa-0">
            <v-row class="version-history-table ma-0">
              <v-col cols="12" class="pa-0">
                <v-data-table
                  :items="mapperList"
                  :hide-default-footer="true"
                  :fixed-header="true"
                  class="analyzed-layout-table"
                  disable-pagination
                  disable-sort
                  :height="customHeight"
                >
                  <template v-slot:body="{ items }">
                    <thead>
                      <tr>
                        <th class="text-center text-version" style="width:51px">
                          {{ $t('tbl.mapManager.versionHistory.ver') }}
                        </th>
                        <th class="text-center text-version" colspan="2" style="width:117px">
                          {{ $t('tbl.mapManager.versionHistory.select') }}
                        </th>
                        <th class="text-center text-version" style="width:133px">
                          {{ $t('tbl.mapManager.versionHistory.date') }}
                        </th>
                        <th class="text-center text-version">
                          {{ $t('tbl.mapManager.versionHistory.user') }}
                        </th>
                        <th class="text-center text-version">
                          {{ $t('tbl.mapManager.versionHistory.changeHistory') }}
                        </th>
                        <th v-if="isDlb === true" class="text-center text-version">
                          {{ $t('tbl.mapManager.versionHistory.executeFile') }}
                        </th>
                        <th class="text-center text-version" style="width:60px">
                          {{ $t('tbl.mapManager.versionHistory.delete') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <td class="text-center text-bold">{{ item.MAPP_VER }}</td>
                        <td
                          v-if="item.CURVER_YN === 'Y'"
                          class="text-left  align-radio"
                          style="width:29px"
                        >
                          <input
                            type="radio"
                            v-model="item.CURVER_YN"
                            :value="item.CURVER_YN"
                            name="matched-map"
                            @click="selectVersion(item)"
                          />
                        </td>
                        <td
                          v-if="item.CURVER_YN === 'N'"
                          class="text-left  align-radio"
                          style="width:29px"
                        >
                          <input type="radio" name="matched-map" @click="selectVersion(item)" />
                        </td>
                        <td class="text-left" style="width:87px">
                          <a @click="openCheckOut(item)">{{
                            $t('tbl.mapManager.versionHistory.checkOut')
                          }}</a>
                        </td>
                        <td class="text-left">{{ item.CRE_DT }}</td>
                        <td class="text-left text-bold">{{ item.CRE_USR }}</td>
                        <td class="text-left">{{ item.CHKIN_COMT }}</td>
                        <td v-if="isDlb === true" class="text-left" style="width:87px">
                          <a @click="downloadFiOb(item)">{{
                            $t('tbl.mapManager.versionHistory.download')
                          }}</a>
                        </td>
                        <td class="text-center">
                          <v-btn
                            v-if="
                              item.CURVER_YN === 'Y' || item.MAPP_VER === currentSelect.MAPP_VER
                            "
                            small
                            disabled
                            text
                            icon
                          >
                            <icon-svg :disabled="true" iconName="delete" />
                          </v-btn>
                          <v-btn v-else small text icon @click="deleteItem(item)">
                            <icon-svg iconName="delete" />
                          </v-btn>
                          <!-- <v-btn v-if="item.CURVER_YN === 'Y'" small disabled text icon  @click="deleteItem(item)">
                            <v-icon color="popup-col-delete darken-1" small>far fa-trash-alt</v-icon>
                          </v-btn>
                          <v-btn v-if="item.CURVER_YN === 'N'" small text icon @click="deleteItem(item)">
                            <v-icon color="popup-col-delete darken-1" small>far fa-trash-alt</v-icon>
                          </v-btn> -->
                        </td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">{{ $t('btn.common.reset') }}</v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->

      <!-- [S]  Popup buttons-->
      <v-card-text class="footer-display-popup">
        <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
        <v-row class="ma-0 mt-2">
          <v-col cols="12" class="button-col action-col">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-popup btn-delete" tile @click="removeDialog">
                {{ $t('btn.common.close') }}
              </v-btn>
              <v-btn
                class="btn btn-popup btn-search"
                color="primary"
                tile
                @click="saveVersionHistory"
                v-if="this.options.item.action != 'mapbuilder'"
                :disabled="oldVersion === currentSelect.MAPP_VER"
              >
                {{ $t('btn.common.save') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup buttons-->
    </v-card>
    <dialogWindow
      ref="warningDialog"
      size="max"
      :detail="$t('msg.common.warning.detailWarningCheckIn')"
      color="warning"
    >
    </dialogWindow>
    <dialogWindow
      ref="checkOutDialog"
      size="max"
      :detail="$t('msg.common.warning.detailOkConfirm')"
      color="confirmation"
      show-cancel="true"
      @select-close="onClickCancel"
      @select-ok="onClickOkay"
    >
    </dialogWindow>
    <dialogWindow
      ref="deleteDialog"
      size="max"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the mapper'])"
      color="confirmation"
      show-cancel="true"
      @select-ok="onClickDelete"
    >
    </dialogWindow>
    <dialogWindow
      ref="successDialog"
      size="max"
      :detail="$t('msg.common.deploySuccess', ['Mapper version'])"
      color="success"
      @select-ok="onClickSave"
    >
    </dialogWindow>
    <dialogWindow
      ref="downloadFail"
      size="max"
      :detail="$t('msg.common.warning.notFindTargetFile')"
      color="warning"
    >
    </dialogWindow>
    <dialogWindow
      ref="moveMapbuilder"
      size="max"
      :detail="$t('msg.common.warning.moveConfirm', [this.mapperName])"
      color="confirmation"
      show-cancel="true"
      @select-ok="onClickMove"
    >
    </dialogWindow>
    <dialogWindow
      ref="warningCheckedOutDialog"
      size="max"
      :detail="$t('msg.common.warning.detailWarningIsCheckedOut', ['mapper', updateUserId])"
      color="validation"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */
import { mapState } from 'vuex';

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
/* 2020/11/06 203737 Remove unused source
import controlData from '../Data/asset-creation/data_control.json';*/
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { DownloadFile } from '@/vue-dlb/models/DownloadFile';
import cfg from '@/vue-caas/config/config.js';
// 2021.12.06 SPKA-304 svg icon
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
  },
  /* 2020/10/29 203737 Change prop definitions
    props: ['id', 'title', 'options', 'eventCb', 'selectFile', 'closeDialog', 'dragStart', 'dragEnd', 'fileSelected', 'dialogCheckIn', 'versionList','reFreshList'],*/
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    dialogCheckIn: Function,
    versionList: Object,
    reFreshList: Function,
    closeWFAndMoveMapBuilder: Function,
  },
  name: 'flatFile-layout-list',
  data: () => ({
    fileId: null,
    mapperName: '',
    warningDialog: false,
    checkOutDialog: false,
    /* 2020/11/06 203737 Remove unused source
      selectedDelete: null,*/
    lockedFlag: false,
    successDialog: false,
    downloadDialog: false,
    downloadFail: false,
    moveMapbuilder: false,
    mapperData: [],
    /* 2020/11/06 203737 Remove unused source
      map_table_header : controlData[0].flatFile_version_table_header,
      map_table_data : controlData[0].flatFile_version_table_data,*/
    versionHistoryItems: {
      header: ['MAP_PRCS_NO'],
      data: [
        {
          MAP_PRCS_NO: '',
        },
      ],
    },
    currentVerItems: {
      header: ['MAP_KIND', 'MAP_PRCS_NO', 'MAP_HST_NO', 'FILE_ID', 'CODE_CTG_ID'],
      data: [
        {
          MAP_KIND: '',
          MAP_PRCS_NO: '',
          MAP_HST_NO: '',
          FILE_ID: '',
          CODE_CTG_ID: '',
        },
      ],
    },
    lockItems: {
      header: ['MAP_KIND', 'MAP_PRCS_NO', 'LOCK_YN'],
      data: [
        {
          MAP_KIND: '',
          MAP_PRCS_NO: '',
          LOCK_YN: '',
        },
      ],
    },
    deleteItems: {
      header: ['MAP_KIND', 'MAP_PRCS_NO', 'MAP_HST_NO', 'FILE_ID'],
      data: [
        {
          MAP_KIND: '',
          MAP_PRCS_NO: '',
          MAP_HST_NO: '',
          FILE_ID: '',
        },
      ],
    },
    /* 2020/11/06 203737 Remove unused source
      viewFileItems: {
        header: ['FILE_ID'],
        data: [{
          FILE_ID: ''
        }]
      },*/
    isDlb: false,
    oldVersion: '',
    currentSelect: {},
    isCheckedOut: false,
    updateUserId: '',
    customHeight: 70,
    win: null,
  }),
  created() {
    this.isDlb = cfg.isDlb;
    this.mapperName = this.versionList.MAPPER_NAME;
    this.queryList();
    this.isCheckedOut = this.options.item.data.isCheckedOut;
    this.updateUserId = this.options.item.data.MAP_UPD_USR;
  },
  computed: {
    ...mapState('map', {
      mapperList: 'mapperList',
      scannerList: 'scannerList',
    }),
    ...mapState('common', {
      fileContent: 'fileContent',
    }),
  },
  methods: {
    queryList() {
      this.versionHistoryItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
      Store.dispatch('map/queryMapperHistoryList', this.versionHistoryItems).then(() => {
        console.log('--------- Finished to process ----------');
        this.currentSelect = this.mapperList.find((e) => e.CURVER_YN === 'Y');
        let len = this.mapperList.length;
        this.customHeight = (len > 6 ? 6 : len + 1) * 35;
        this.oldVersion = this.currentSelect.MAPP_VER;
      });
    },
    saveVersionHistory() {
      // 2021.9.29 203728 not use
      // if(this.currentVerItems.data[0].MAP_HST_NO == ''){
      //   let filtered = data.filter(item => item.CURVER_YN === 'Y')
      //   this.currentVerItems.data[0].MAP_HST_NO = filtered[0].HST_NO + "";
      // }
      this.currentVerItems.data[0].MAP_KIND = 'MAPP';
      this.currentVerItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
      this.currentVerItems.data[0].CODE_CTG_ID = this.versionList.CODE_CTG_ID;
      Store.dispatch('map/saveCurrentVer', this.currentVerItems).then(() => {
        console.log('--------- Finished to process ----------');
        this.$refs.successDialog.dialog = true;
        this.queryList();
      });
    },
    onClickSave() {
      this.reFreshList();
      this.removeDialog({});
    },
    selectVersion(item) {
      // 2021.9.29 203728 current row
      this.currentSelect = item;
      this.currentVerItems.data[0].MAP_HST_NO = item.HST_NO + '';
      this.currentVerItems.data[0].FILE_ID = item.FILE_ID;
    },
    updateCheckIn() {
      Store.dispatch('map/checkInUpdata', this.checkInUpdata).then(() => {
        console.log('--------- Finished to process ----------');
      });
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    /* 2020/10/28 203737 Remove unused source
      selectFlatFile (item){
        this.removeDialog({});
        this.selectFile(item);
      },*/
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    /* 2020/10/28 203737 Remove unused source
      findIndexItem(item, arr, col) {
        let prop = (typeof col == 'undefined') ? 'id' : col;
        let index = arr.findIndex((row) => {
          return row[prop] === item[prop]
        })
        return (index > -1) ? index : null
      },*/
    openCheckIn() {
      if (this.versionList.MAP_MAPP_CHKIN_YN === 'N' && this.lockedFlag === false) {
        this.$refs.warningDialog.dialog = true;
        return;
      }
      if (this.isCheckedOut) {
        this.$refs.warningCheckedOutDialog.dialog = true;
        return;
      }
      //  2021.4.7 203728 Send data for Map checkin
      this.dialogCheckIn(this.options.item.data);
    },
    openCheckOut(item) {
      this.fileId = item;
      console.log(JSON.stringify(item));
      this.$refs.checkOutDialog.dialog = true;
    },
    downloadFiOb(item) {
      let downloadfile = new DownloadFile();
      if (item.TARGET_FILE_ID === '' || item.TARGET_FILE_ID === null) {
        this.$refs.downloadFail.dialog = true;
      } else {
        downloadfile.data[0].FILE_ID = item.TARGET_FILE_ID;
        downloadfile.data[0].SAVE_NAME = item.TARGET_FILE_NAME;
        Store.dispatch('common/DownloadFileFromServer', downloadfile).then(() => {
          console.log('--------- Finished to process ----------');
        });
      }
    },
    // downloadFife(){
    //   let downloadfile = new DownloadFile();
    //   downloadfile.data[0].FILE_ID = this.fileId.FILE_ID;
    //   downloadfile.data[0].SAVE_NAME = this.versionList.MAPPER_NAME;
    //   Store.dispatch("common/DownloadFileFromServer", downloadfile).then(() => {
    //     console.log("--------- Finished to process ----------");
    //   });
    // },
    viewFile() {
      Store.dispatch('common/viewFileData', this.fileId.FILE_ID).then(() => {
        // console.log("--------- Finished view File ----------");
        this.mapperData = [];
        this.mapperData.push(this.fileContent);
        this.mapperData.push(this.fileId);
        // this.$emit('mapperData',mapperData);
      });
    },
    viewFileMoveMapBuilder() {
      Store.dispatch('common/viewFileData', this.fileId.FILE_ID).then(() => {
        // console.log("--------- Finished view File ----------");
        const query = new URLSearchParams({
          mapId: this.versionList.MAP_PRCS_NO,
          ver: this.fileId.MAPP_VER,
          flag: 'Y',
          tab: 'Mapper',
        }).toString();
        this.removeDialog({});
        window.open(`/transformation/mapbuilder?${query}`);
      });
    },
    onClickOkay() {
      if (this.isCheckedOut) {
        this.$refs.warningCheckedOutDialog.dialog = true;
        return;
      }
      this.lockItems.data[0].MAP_KIND = 'MAPP';
      this.lockItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
      this.lockItems.data[0].LOCK_YN = 'Y';
      Store.dispatch('map/updateLock', this.lockItems).then(() => {
        console.log('--------- Finished to process CHECKOUT ----------');
        this.lockedFlag = true;
        this.reFreshList();
        if (this.options.item.action == 'mapbuilder') {
          this.viewFile();
          //  this.downloadFife();
        } else {
          // this.downloadFife();
        }
      });
      this.$refs.moveMapbuilder.dialog = true;
    },
    onClickCancel() {
      // if(this.options.item.action !='mapbuilder'){
      //      this.downloadFife();
      // }
      this.$refs.moveMapbuilder.dialog = true;
    },
    onClickMove() {
      this.viewFileMoveMapBuilder();
      this.$refs.moveMapbuilder.dialog = false;
    },
    deleteItem(item) {
      this.seletedDelete = item;
      this.$refs.deleteDialog.dialog = true;
    },
    onClickDelete() {
      let item = this.seletedDelete;
      this.deleteItems.data[0].MAP_KIND = 'MAPP';
      this.deleteItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
      this.deleteItems.data[0].MAP_HST_NO = item.HST_NO;
      this.deleteItems.data[0].FILE_ID = item.FILE_ID;
      Store.dispatch('map/deleteSelectedHistory', this.deleteItems).then(() => {
        this.queryList();
        console.log('--------- Finished to process ----------');
      });
    },
  },
};
</script>

<style>
.tab-text {
  padding-left: 5px !important;
  justify-content: left !important;
}
.v-tabs.theme--dark > .v-item-group {
  background-color: #424242 !important;
}
.v-tabs.theme--dark > .v-item-group > .v-window.v-item-group {
  background-color: #424242 !important;
}
.analyzed-layout-dialog
  .v-text-field.search-matched-map-list-button
  .v-input__control
  .v-input__slot {
  width: 190px;
  margin: 0px !important;
}
.analyzed-layout-dialog .search-button {
  margin: 0px !important;
}
.analyzed-layout-table a {
  font-weight: bold;
  text-decoration: underline;
  color: #0082ba !important;
}
.analyzed-layout-table table td {
  border-top: 0px !important;
  font-weight: normal !important;
  font-size: 11px !important;
}

.theme--dark .mapper-version .dialog-body {
  border-left: none;
}

.theme--dark .mapper-version .dialog-body .v-sheet {
  background-color: #25272e !important;
  border-left: none !important;
}
.content-covering-m {
  margin: 0px !important;
  padding: 20px 15px 15px 15px !important;
  background: #fafcff;
  border: 1px solid #f0f7fb;
  box-sizing: border-box;
  border-radius: 3px;
}
.theme--dark .content-covering-m {
  background-color: #292c35;
  border: none;
}
.footer-display-popup {
  padding: 0px !important;
}
.top-btn-display-m {
  padding: 0px !important;
}
.content-version-section {
  padding: 5px 0px 10px 0px;
}
.text-version,
.analyzed-layout-table table td.text-bold {
  font-weight: 600 !important;
  font-size: 11px;
  line-height: 15px;
}
.theme--dark .analyzed-layout-table table td.text-bold {
  color: #bbbbbb !important;
}
.version-history-table {
  max-width: 750px;
}
.version-history-table .v-data-table__wrapper {
  background: #fafcff;
  overflow-x: hidden;
}
.theme--dark .version-history-table .v-data-table__wrapper {
  background-color: #292c35;
}
.theme--dark .mapper-version .version-history-table table {
  border-right: none !important;
}
.theme--dark .version-history-table .v-data-table tbody tr td:not(.v-data-table__mobile-row) {
  border: none !important;
  border-right: 1px solid #525860 !important;
  border-bottom: 1px solid #525860 !important;
}
.mapper-version .analyzed-layout-table table td,
.mapper-version .analyzed-layout-table table thead th {
  border: none;
  border-right: 1px solid #d0d4dd;
}
.version-history-table .v-data-table thead tr:last-child th {
  border-right: 1px solid #d0d4dd;
  border-left: none;
}
.top-btn-display {
  padding: 15px 30px 0px 30px !important;
}
.align-radio {
  line-height: 0;
  display: table-cell;
  vertical-align: middle;
}
.theme--dark .version-history-table .v-data-table--fixed-header thead th {
  background: #595b64 !important;
}
.theme--dark .version-history-table .v-data-table thead tr:last-child th {
  color: #ffffff !important;
}
</style>
